/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'confluence-table-tree.column.contributors': 'Közreműködők',
  'confluence-table-tree.column.last-modified': 'Utolsó módosítás',
  'confluence-table-tree.column.title': 'Név',
  'confluence-table-tree.could-not-load': 'Nem sikerült betölteni',
  'confluence-table-tree.could-not-load-contributors': 'Nem sikerült betölteni a közreműködőket',
  'confluence-table-tree.create-child-page': 'Alárendelt oldal létrehozása',
  'confluence-table-tree.create-page': 'Oldal létrehozása',
  'confluence-table-tree.default.page.title': 'Névtelen',
  'confluence-table-tree.default.show-all-pages-button.label': 'Több oldal megjelenítése',
  'confluence-table-tree.draft.lozenge': 'PISZKOZAT',
  'confluence-table-tree.draft.tooltip': 'Csak te láthatod a piszkozatokat',
  'confluence-table-tree.drafts-toggle.label': 'Piszkozatok megjelenítése',
  'confluence-table-tree.edit': 'Szerkesztés',
  'confluence-table-tree.edit-in-confluence': 'Szerkesztés Confluence-ben',
  'confluence-table-tree.empty.description':
    'Hozz létre megbeszélésfeljegyzéseket, termékkövetelményeket, döntéseket vagy más tartalmakat, amelyekkel megtöltheted ezt a munkateret.',
  'confluence-table-tree.empty.title': 'Ez a hely tele van lehetőséggel',
  'confluence-table-tree.error.description': 'Ezek az oldalak nem jeleníthetők meg. Próbáld meg újra később.',
  'confluence-table-tree.error.row': 'Nem lehet betölteni az oldalakat.',
  'confluence-table-tree.error.title': 'Elnézést kérünk!',
  'confluence-table-tree.friendly-when-created': 'Létrehozva',
  'confluence-table-tree.friendly-when-updated': 'Frissítve',
  'confluence-table-tree.share.copied': 'Vágólapra másolva',
  'confluence-table-tree.share.copy-button': 'Másolás',
  'confluence-table-tree.share.subtitle': 'Link megosztása',
  'confluence-table-tree.share.title': 'Oldal megosztása',
  'confluence-table-tree.share.tooltip': 'Megosztás',
  'confluence-table-tree.view-profile': 'Profil megtekintése',
};
